import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { API } from "../utils/apk";
import Cookies from "js-cookie";
import { handleImageChange } from "../Helpers/uploadtoBucket";

function Register() {
  const [itemName, setItemName] = useState("");
  const [itemCategory, setItemCategory] = useState("");
  const [itemCode, setItemCode] = useState();
  const [itemRate, setItemRate] = useState();
  const [cgst, setCgst] = useState();
  const [sgst, setSgst] = useState();
  const [unit, setUnit] = useState();
  const [type, setType] = useState("");
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [offer, setOffer] = useState();
  const [offerPrice, setOfferPrice] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [items, setItems] = useState([]);
  const token = Cookies.get("authToken");
  const [editId, setEditId] = useState(null); // Track the ID of the row being edited
  const [editedItem, setEditedItem] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [minQty, setMinQty] = useState("");
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [visibleItems, setVisibleItems] = useState([]); // Currently visible items
  const [hasMore, setHasMore] = useState(true); //
  const itemsPerPage = 10;
  const adminId = localStorage.getItem("adminId");
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [newUnit, setNewUnit] = useState("");
  const [newType, setNewType] = useState("");
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [unitOptions, setUnitOptions] = useState(["pcs", "plate"]);
  const [typeOptions, setTypeOptions] = useState(["full", "half", "quarter"]);
  const [updatePercentage, setUpdatePercentage] = useState("");
  const [updateType, setUpdateType] = useState("");
  const [percentage, setPercentage] = useState("");
const [categories, setCategories] = useState([]);
const [selectedCategory, setSelectedCategory] = useState("");
  let uniqueCategories = [...new Set(items?.map((item) => item.itemCategory))];
  // console.log("uniquecategories", uniqueCategories);
  const loadMoreItems = () => {
    const currentLength = visibleItems.length;
    const nextItems = items.slice(currentLength, currentLength + itemsPerPage);

    setVisibleItems((prev) => [...prev, ...nextItems]);
    if (visibleItems.length + nextItems.length >= items.length) {
      setHasMore(false); // No more data to load
    }
  };

  // Scroll event handler
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 20 && hasMore) {
      loadMoreItems();
    }
    console.log("client height", clientHeight, "scroll height", scrollHeight);
  };
  useEffect(() => {
    fetchData();
  }, [adminId]);
  // const fetchData = async () => {
  //   try {
  //     const response = await axios.get(`${API}/get/all/item`);
  //     // console.log(response.data.reverse());
  //     setItems(response.data?.data);
  //     setVisibleItems(response.data.slice(0, itemsPerPage));
  //   } catch (error) {
  //     console.log(error.response.data.message);
  //     toast.error(error.response.data.message);
  //   }
  // };
  const fetchData = async () => {
    try {
      const response = await axios.get(`${API}/get/all/item`);
      console.log("get all item", response);
      // Check if the data structure is an array and update accordingly
      const data = response.data?.data;

      // Ensure data is an array and reverse it if necessary
      if (Array.isArray(data)) {
        // Reverse the data and set the state
        setItems(data.reverse()); // If you want to reverse the array
        setVisibleItems(data);
      } else {
        throw new Error("Data is not an array.");
      }
    } catch (error) {
      // Log and display error message from response if available
      const errorMessage =
        error.response?.data?.message || "An error occurred.";
      console.error("Error fetching data:", errorMessage);
      toast.error(errorMessage); // Show error toast
    }
  };

  useEffect(() => {
    if (itemRate && offer) {
      const calculatedOfferPrice = itemRate - itemRate * (offer / 100);
      setOfferPrice(calculatedOfferPrice.toFixed(2)); // Rounds to 2 decimal places
    }
  }, [itemRate, offer]);
  useEffect(() => {
    const fetchItemByCode = async () => {
      if (itemCode && itemName === "") {
        try {
          const response = await axios.get(`${API}/get/item/by/${itemCode}`);
          if (response.data) {
            const itemData = response.data;
            if (Object.keys(itemData).length > 0) {
              setItemName(itemData.itemName || "");
              setItemCategory(itemData.itemCategory || "");
              setItemRate(itemData.itemRate || "");
              setCgst(itemData.cgst || "");
              setSgst(itemData.sgst || "");
              setUnit(itemData.unit || "");
              setType(itemData.type || "");
              setImageUrl(itemData.image || "");
              setOffer(itemData.offer || "");
              setOfferPrice(itemData.offerPrice || "");
              setMinQty(itemData.minQty || "");
              setFromDate(itemData.fromDate || "");
              setToDate(itemData.toDate || "");
              toast.success("Item details fetched successfully.");
            } else {
              setItemName("");
              setItemCategory("");
              setItemRate("");
              setCgst("");
              setSgst("");
              setUnit("");
              setType("");
              setOffer("");
              setImageUrl(null);
              setOfferPrice("");
              setMinQty("");
              setFromDate("");
              setToDate("");
              setToDate("");
            }
          }
        } catch (error) {
          console.log(
            "Error fetching item by code:",
            error.response?.data?.message || error.message
          );
        }
      }
    };
    fetchItemByCode();
  }, [itemCode]);

  const clearData = () => {
    setItemCode("");
    setItemName("");
    setItemCategory("");
    setItemRate("");
    setCgst("");
    setSgst("");
    setUnit("");
    setType("");
    setOffer("");
    setImageUrl(null);
    setOfferPrice("");
    setMinQty("");
    setFromDate("");
    setToDate("");
  };
  useEffect(() => {
    const fetchItemByCode = async () => {
      if (itemName) {
        try {
          const response = await axios.get(`${API}/get/item/info/${itemName}`);
          console.log("response name", response.data);
          if (response.data) {
            const itemData = response.data;
            if (Object.keys(itemData).length > 0) {
              setItemCode(itemData.itemCode || "");
              setItemCategory(itemData.itemCategory || "");
              setItemRate(itemData.itemRate || "");
              setCgst(itemData.cgst || "");
              setSgst(itemData.sgst || "");
              setUnit(itemData.unit || "");
              setType(itemData.type || "");
              setImageUrl(itemData.image || "");
              setOffer(itemData.offer || "");
              setMinQty(itemData.minQty || "");
              setFromDate(itemData.fromDate || "");
              setToDate(itemData.toDate || "");
            } else {
              setItemCode("");
              setItemCategory("");
              setItemRate("");
              setCgst("");
              setSgst("");
              setUnit("");
              setType("");
              setOffer("");
              setImageUrl(null);
              setMinQty("");
              setFromDate("");
              setToDate("");
            }
          }
        } catch (error) {
          console.log(
            "Error fetching item by code:",
            error.response?.data?.message || error.message
          );
        }
      }
    };
    fetchItemByCode();
  }, [itemName]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      itemCode,
      itemName,
      itemCategory,
      itemRate,
      sgst,
      cgst,
      unit,
      type,
      image: imageUrl,
      offer,
      fromDate,
      toDate,
      offerPrice,
      minQty,
    };
    try {
      const response = await axios.post(API + "/create/item", payload);
      if (response.data) {
        toast.success("Item Created Successfully");
        // Reset form fields
        setItemName("");
        setItemCategory("");
        setItemCode("");
        setCgst("");
        setSgst("");
        setImage("");
        setItemRate("");
        setOffer("");
        setType("");
        setUnit("");
        setOfferPrice("");
        setFromDate("");
        setToDate("");
        setImage("");
        setImageUrl("");
      }
      fetchData();
    } catch (error) {
      console.log("error while creating item", error.response.data.message);

      toast.error(error.response.data.message);
      console.log("token", token);
      console.log(payload);
    }
  };

  const handleEdit = async (id) => {
    const itemToEdit = items.find((item) => item._id === id);
    setEditId(id);
    setEditedItem({ ...itemToEdit });
    // toast.success("Item Edited Successfully");
  };

  // Handle when "Save" is clicked
  const handleSave = async (id) => {
    try {
      const response = await axios.put(API + "/update/item/" + id, {
        ...editedItem,
      });
      if (response.data) {
        const updatedItems = items.map((item) =>
          item._id === id ? editedItem : item
        ); // Update the item with the new edited values
        console.log("updatedItems", id);
        setItems(updatedItems); // Save updated items
        setEditId(null);
        toast.success("Item Updated Successfully");
        fetchData();
      }
    } catch (error) {
      console.log("error while editing item", error);
      toast.error(error.response.data.message);
    }
    // Exit edit mode
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // Handle input changes

  const handleDelete = async (id) => {
    console.log("id", id);
    try {
      const response = await axios.delete(API + "/delete/item/" + id);
      if (response.data) {
        toast.success("Item Deleted Successfully");
        fetchData();
      }
    } catch (error) {
      console.log("error while deleting item", error.response.data.message);
      toast.error(error.response.data.message);
    }
  };

  const handleStatusToggle = async (id) => {
    try {
      const response = await axios.put(API + "/update/status/" + id);
      if (response.data) {
        toast.success("Item Status Updated Successfully");
        fetchData();
      }
    } catch (error) {
      console.log(
        "error while updating item status",
        error.response.data.message
      );
      toast.error(error.response.data.message);
    }
  };
  const handleCategorySubmit = () => {
    if (newCategory.trim()) {
      const newItem = {
        itemCategory: newCategory.trim(),
        itemName: "",
        itemCode: "",
      };

      setItems((prevItems) => [...prevItems, newItem]);

      setShowModal(false);
      setNewCategory("");
    }
  };
  const handleImageChange = async (e, setImageUrl, setImage) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file); // 👈 Make sure field name is 'image'

    try {
      const res = await fetch(`${API}/upload-image`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.success) {
        console.log("Uploaded image path:", data.filePath);
        setImageUrl(`https://api.surajrestaurant.in/${data.filePath}`); // ⬅️ Final public image URL
        setImage(file); // Optional: save file
      } else {
        console.error("Upload failed:", data.message);
      }
    } catch (err) {
      console.error("Error uploading image:", err.message);
    }
  };

  // Handle submitting the new unit
  const handleUnitSubmit = () => {
    if (newUnit.trim()) {
      // Add the new unit to the unit options
      setUnitOptions((prevOptions) => [...prevOptions, newUnit.trim()]);
      setShowUnitModal(false);
      setNewUnit("");
    } else {
      alert("Please enter a unit");
    }
  };

  // Handle submitting the new type
  const handleTypeSubmit = () => {
    if (newType.trim()) {
      // Add the new type to the type options
      setTypeOptions((prevOptions) => [...prevOptions, newType.trim()]);
      setShowTypeModal(false);
      setNewType("");
    } else {
      alert("Please enter a type");
    }
  };

  const handleIncrease = async () => {
    if (!percentage || isNaN(percentage)) {
      toast.error("Enter valid percentage");
      return;
    }

    try {
      const res = await axios.post(
        `https://api.surajrestaurant.in/101/update/itemRate`,
        { percentage: Number(percentage) }
      );

      toast.success(res.data.message);
      fetchData();
      setPercentage("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    }
  };

const handleResetPrices = async () => {
  try {
    const res = await axios.put(`https://api.surajrestaurant.in/101/reset/increased/price`);
    toast.success(res.data.message);
    fetchData(); // refresh table after reset
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};



const fetchCategories = async () => {
  try {
    const res = await axios.get(`https://api.surajrestaurant.in/101/get/all/category`);
    console.log("CATEGORY RESPONSE:", res.data);
    
    setCategories(res.data.categories || []);  // ✅ Correct key
  } catch (error) {
    toast.error("Failed to load categories");
  }
};


useEffect(() => {
  fetchCategories();
}, []);

const handleUpdateStatusByCategory = async () => {
  if (!selectedCategory) {
    return toast.error("Please select a category");
  }

  try {
    const res = await axios.put(
      `https://api.surajrestaurant.in/101/update/status/by/category`,
      { category: selectedCategory }
    );

    toast.success(res.data.message);
    fetchData(); // refresh items in table

  } catch (error) {
    toast.error(error.response?.data?.message || "Error updating status");
  }
};


  return (
    <div className="w-full  mx-auto p-4  shadow-md mt-4 mb-8 rounded-lg  bg-gray-40 ">
      {/* <h2 className="text-lg font-semibold mb-4">Item Form</h2> */}
      <form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <div className="w-full flex flex-row flex-nowrap gap-2 overflow-x-auto bg-blue-200 border-b border-dashed border-white px-4">
          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="itemCode">
              Item Code
            </label>
            <input
              type="text"
              id="itemCode"
              name="itemCode"
              className="w-full border border-gray-300 rounded p-1"
              value={itemCode}
              onChange={(e) => setItemCode(e.target.value)}
              onClick={clearData}
              required
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="itemName">
              Item Name
            </label>
            <input
              type="text"
              id="itemName"
              name="itemName"
              className="w-full border border-gray-300 rounded p-1"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              required
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="itemCategory">
              Category
            </label>
            <div className="flex items-center">
              <select
                id="itemCategory"
                className="w-full border border-gray-300 rounded p-1"
                value={itemCategory || ""}
                onChange={(e) => {
                  const selectedCategory = e.target.value;
                  if (selectedCategory) {
                    setItemCategory(selectedCategory);
                    setType(selectedCategory);
                  } else {
                    setItemCategory("");
                  }
                }}
                required
              >
                <option value="">Select Category</option>
                {uniqueCategories?.map((item, index) => (
                  <option key={index} value={item.trim()}>
                    {item.trim()}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="bg-green-600 text-white rounded font-bold ml-2 px-2"
                onClick={() => setShowModal(true)}
              >
                +
              </button>
            </div>
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="itemRate">
              Item Rate
            </label>
            <input
              type="number"
              id="itemRate"
              name="itemRate"
              className="w-full border border-gray-300 rounded p-1"
              value={itemRate}
              onChange={(e) => setItemRate(e.target.value)}
              required
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="cgst">
              CGST %
            </label>
            <input
              type="number"
              id="cgst"
              name="cgst"
              className="w-full border border-gray-300 rounded p-1"
              value={cgst}
              onChange={(e) => {
                setCgst(e.target.value);
                setSgst(e.target.value);
              }}
              required
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="sgst">
              SGST %
            </label>
            <input
              type="number"
              id="sgst"
              name="sgst"
              className="w-full border border-gray-300 rounded p-1"
              value={sgst}
              onChange={(e) => setSgst(e.target.value)}
              required
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="unit">
              Unit
            </label>
            <div className="flex items-center">
              <select
                id="unit"
                className="w-full border border-gray-300 rounded p-1"
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
                required
              >
                <option value="">Select Unit</option>
                {unitOptions.map((unitOption, index) => (
                  <option key={index} value={unitOption}>
                    {unitOption}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="bg-blue-600 text-white rounded font-bold ml-2 px-2"
                onClick={() => setShowUnitModal(true)}
              >
                +
              </button>
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="w-full flex flex-row flex-nowrap gap-2 overflow-x-auto bg-blue-200 border-b border-dashed border-white px-4">
          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="type">
              Type
            </label>
            <div className="flex items-center">
              <select
                id="type"
                className="w-full border border-gray-300 rounded p-1"
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
              >
                <option value="">Select Type</option>
                {typeOptions.map((typeOption, index) => (
                  <option key={index} value={typeOption}>
                    {typeOption}
                  </option>
                ))}
              </select>
              <button
                type="button"
                className="bg-blue-600 text-white rounded font-bold ml-2 px-2"
                onClick={() => setShowTypeModal(true)}
              >
                +
              </button>
            </div>
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="fromDate">
              From Date
            </label>
            <input
              type="date"
              id="fromDate"
              className="w-full border border-gray-300 rounded p-1"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="toDate">
              To Date
            </label>
            <input
              type="date"
              id="toDate"
              className="w-full border border-gray-300 rounded p-1"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="Offer">
              Offer %
            </label>
            <input
              type="number"
              id="Offer"
              className="w-full border border-gray-300 rounded p-1"
              value={offer}
              onChange={(e) => setOffer(e.target.value)}
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="offerPrice">
              Offer Price
            </label>
            <input
              type="number"
              id="offerPrice"
              className="w-full border border-gray-300 rounded p-1"
              value={offerPrice}
              placeholder="Offer Price will be calculated"
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="minQty">
              Min Qty
            </label>
            <input
              type="number"
              id="minQty"
              className="w-full border border-gray-300 rounded p-1"
              value={minQty}
              onChange={(e) => setMinQty(e.target.value)}
            />
          </div>

          <div className="w-[14.28%]">
            <label className="block font-bold" htmlFor="image">
              Image
            </label>
            <input
              type="file"
              id="image"
              className="w-full border border-gray-300 rounded p-1"
              accept="image/*"
              onChange={(e) => handleImageChange(e, setImageUrl, setImage)}
            />
            {imageUrl && (
              <img
                src={imageUrl}
                alt="Uploaded"
                className="mt-2 w-full max-h-24 object-contain rounded shadow"
              />
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="w-full flex justify-end bg-blue-200 px-4 py-2">
          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-6 rounded hover:bg-blue-600"
          >
            Submit
          </button>
        </div>
      </form>
      {/* Increase / Decrease Item Rate Section */}
      <div className="w-full   rounded border">

        <div className="flex gap-3 items-center">
          <input
            type="number"
            placeholder="Enter percentage (e.g. 10)"
            className="border border-gray-300 p-2 rounded w-40"
            value={percentage}
            onChange={(e) => setPercentage(e.target.value)}
          />

          <button
            onClick={handleIncrease}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Increase
          </button>
<div className="w-full   rounded border">

  <button
    onClick={handleResetPrices}
    className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
  >
    Reset Increased Prices
  </button>
</div>
{/* Update Item Status by Category */}
<div className="w-full  rounded border">

  <div className="flex gap-3 items-center">

    {/* Dropdown */}
    <select
      className="border border-gray-300 p-2 rounded w-60"
      value={selectedCategory}
      onChange={(e) => setSelectedCategory(e.target.value)}
    >
      <option value="">Select Category</option>
      {categories.map((cat, index) => (
        <option key={index} value={cat.trim()}>
          {cat.trim()}
        </option>
      ))}
    </select>

    {/* Button */}
    <button
      onClick={handleUpdateStatusByCategory}
      className="bg-purple-700 text-white px-4 py-2 rounded hover:bg-purple-800"
    >
      Toggle Status
    </button>

  </div>
</div>

        </div>

      </div>

      <h2 className="text-lg font-semibold mt-4">Added Items</h2>
      <div
        onScroll={handleScroll}
        className="w-full h-[80vh] overflow-auto border rounded-md"
      >
        <table className="min-w-full table-auto border-collapse text-sm md:text-base bg-white">
          <thead>
            <tr className="sticky top-0 bg-blue-900 text-white z-10">
              <th className="py-2 px-3 border whitespace-nowrap">Item Code</th>
              <th className="py-2 px-3 border whitespace-nowrap">Item Name</th>
              <th className="py-2 px-3 border whitespace-nowrap">Category</th>
              <th className="py-2 px-3 border whitespace-nowrap">Rate</th>
              <th className="py-2 px-3 border whitespace-nowrap">CGST %</th>
              <th className="py-2 px-3 border whitespace-nowrap">SGST %</th>
              <th className="py-2 px-3 border whitespace-nowrap">Type</th>
              <th className="py-2 px-3 border whitespace-nowrap">Offer</th>
              <th className="py-2 px-3 border whitespace-nowrap">Image</th>
              <th className="py-2 px-3 border whitespace-nowrap">Unit</th>
              <th className="py-2 px-3 border whitespace-nowrap">Status</th>
              <th className="py-2 px-3 border whitespace-nowrap">Actions</th>
            </tr>
          </thead>
          <tbody>
            {visibleItems
              .slice()
              .reverse()
              .map((item, index) => (
                <tr
                  key={item._id}
                  className={`${
                    index % 2 === 0 ? "bg-blue-100" : "bg-blue-200"
                  }`}
                >
                  {/* Item Code */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="itemCode"
                        value={editedItem.itemCode}
                        onChange={handleInputChange}
                        className="w-full max-w-[100px] border px-1 py-1"
                      />
                    ) : (
                      item.itemCode
                    )}
                  </td>

                  {/* Item Name */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="itemName"
                        value={editedItem.itemName}
                        onChange={handleInputChange}
                        className="w-full max-w-[150px] border px-1 py-1"
                      />
                    ) : (
                      item.itemName
                    )}
                  </td>

                  {/* Category */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="itemCategory"
                        value={editedItem.itemCategory}
                        onChange={handleInputChange}
                        className="w-full max-w-[130px] border px-1 py-1"
                      />
                    ) : (
                      item.itemCategory
                    )}
                  </td>

                  {/* Rate */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="itemRate"
                        value={
                          editedItem.itemRate == 0
                            ? editedItem.increasedPrice
                            : editedItem.itemRate
                        }
                        onChange={handleInputChange}
                        className="w-full max-w-[80px] border px-1 py-1"
                      />
                    ) : item.itemRate == 0 ? (
                      item.increasedPrice
                    ) : (
                      item.itemRate
                    )}
                  </td>

                  {/* CGST */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="cgst"
                        value={editedItem.cgst}
                        onChange={handleInputChange}
                        className="w-full max-w-[70px] border px-1 py-1"
                      />
                    ) : (
                      item.cgst
                    )}
                  </td>

                  {/* SGST */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="sgst"
                        value={editedItem.sgst}
                        onChange={handleInputChange}
                        className="w-full max-w-[70px] border px-1 py-1"
                      />
                    ) : (
                      item.sgst
                    )}
                  </td>

                  {/* Type */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="type"
                        value={editedItem.type}
                        onChange={handleInputChange}
                        className="w-full max-w-[100px] border px-1 py-1"
                      />
                    ) : (
                      item.type
                    )}
                  </td>

                  {/* Offer */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="text"
                        name="offer"
                        value={editedItem.offer}
                        onChange={handleInputChange}
                        className="w-full max-w-[100px] border px-1 py-1"
                      />
                    ) : (
                      item.offer
                    )}
                  </td>

                  {/* Image */}
                  <td className="px-2 py-1 border">
                    {editId === item._id ? (
                      <div className="flex flex-col items-center gap-1">
                        {editedItem.image && (
                          <img
                            src={editedItem.image}
                            alt="Preview"
                            className="w-16 h-16 object-cover border"
                          />
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleImageChange(e, (url) =>
                              setEditedItem({ ...editedItem, image: url })
                            )
                          }
                          className="text-xs w-full"
                        />
                      </div>
                    ) : (
                      <img
                        src={item.image}
                        alt={item.itemName}
                        className="w-16 h-16 object-cover mx-auto"
                      />
                    )}
                  </td>

                  {/* Unit */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    {editId === item._id ? (
                      <input
                        type="number"
                        name="unit"
                        value={editedItem.unit}
                        onChange={handleInputChange}
                        className="w-full max-w-[70px] border px-1 py-1"
                      />
                    ) : (
                      item.unit
                    )}
                  </td>

                  {/* Status Button */}
                  <td className="px-2 py-1 border whitespace-nowrap">
                    <button
                      type="button"
                      name="status"
                      className={`w-28 px-2 py-1 rounded text-white font-semibold ${
                        item.status === "available"
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                      onClick={() => handleStatusToggle(item._id)}
                    >
                      {item.status}
                    </button>
                  </td>

                  {/* Actions */}
                  <td className="px-2 py-2 border whitespace-nowrap">
                    <div className="flex flex-col md:flex-row gap-2 items-center justify-center">
                      {editId === item._id ? (
                        <button
                          className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                          onClick={() => handleSave(item._id)}
                        >
                          Save
                        </button>
                      ) : (
                        <button
                          className="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600"
                          onClick={() => handleEdit(item._id)}
                        >
                          Edit
                        </button>
                      )}
                      <button
                        className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                        onClick={() => handleDelete(item._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {showUnitModal && (
        <div className="fixed inset-0 flex items-start justify-center bg-gray-500 bg-opacity-50 pt-20">
          <div className="bg-white p-4 rounded shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Add New Unit</h2>
            <input
              type="text"
              value={newUnit}
              onChange={(e) => setNewUnit(e.target.value)}
              className="border border-gray-300 rounded p-2 w-full mb-4"
              placeholder="Enter new unit"
            />
            <div className="flex justify-end">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                onClick={handleUnitSubmit}
              >
                Save
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => setShowUnitModal(false)} // Close unit modal without saving
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showTypeModal && (
        <div className="fixed inset-0 flex items-start justify-center bg-gray-500 bg-opacity-50 pt-20">
          <div className="bg-white p-4 rounded shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Add New Type</h2>
            <input
              type="text"
              value={newType}
              onChange={(e) => setNewType(e.target.value)}
              className="border border-gray-300 rounded p-2 w-full mb-4"
              placeholder="Enter new type"
            />
            <div className="flex justify-end">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                onClick={handleTypeSubmit}
              >
                Save
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => setShowTypeModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for adding a new category */}
      {showModal && (
        <div className="fixed inset-0 flex items-start justify-center bg-gray-500 bg-opacity-50 pt-20 ">
          <div className="bg-white p-4 rounded shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Add New Category</h2>
            <input
              type="text"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              className="border border-gray-300 rounded p-2 w-full mb-4"
              placeholder="Enter new category"
            />
            <div className="flex justify-end">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                onClick={() => {
                  handleCategorySubmit();
                }}
              >
                Save
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded"
                onClick={() => setShowModal(false)} // Close modal without saving
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Register;
